import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import { useSelector } from "react-redux";
import { BoardHeaderDescription } from "~/components/Workspace/BoardHeader/BoardHeaderDescription";
import { centralizedBoardDescriptionSelector } from "~/store/centralizedBoard/selectors";
export const PublicBoardHeaderDescription = /*#__PURE__*/ memo(()=>{
    const description = useSelector(centralizedBoardDescriptionSelector);
    if (!description) return null;
    return /*#__PURE__*/ _jsx(BoardHeaderDescription, {
        className: "mt-0.5",
        description: description
    });
});
PublicBoardHeaderDescription.displayName = "PublicBoardHeaderDescription";
